import type { ReactNode } from 'react';

interface PageShellProps {
  children: ReactNode;
  className?: string;
}

/** Full-height route shell: header + growing main + footer pinned to viewport bottom. */
export function PageShell({ children, className }: PageShellProps): JSX.Element {
  const extra = className ? ` ${className}` : '';
  return (
    <div className={`min-h-screen flex flex-col bg-gray-50 font-sans text-gray-900${extra}`}>
      {children}
    </div>
  );
}

/** Grows to fill space between header and footer on short pages. */
export function PageMain({ children, className }: PageShellProps): JSX.Element {
  const extra = className ? ` ${className}` : '';
  return <main className={`flex-1 flex flex-col${extra}`}>{children}</main>;
}
